import { ReactNode } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

interface PageShellProps {
  title: string;
  description: string;
  canonicalPath: string;
  /** Overrides the sitewide robots directive for this route. */
  robots?: string;
  /** Per-page JSON-LD. */
  structuredData?: Record<string, unknown> | Record<string, unknown>[];
  children: ReactNode;
}

const PageShell = ({
  title,
  description,
  canonicalPath,
  robots,
  structuredData,
  children,
}: PageShellProps) => (
  <>
    <SEOHead
      title={title}
      description={description}
      canonicalPath={canonicalPath}
      robots={robots}
      structuredData={structuredData}
    />
    <Navbar />
    <main id="main-content" tabIndex={-1} className="min-h-screen pt-24 focus:outline-none">
      {children}
    </main>
    <Footer />
  </>
);

export default PageShell;
